import view from "../../views/livestream.js";
import { router } from "../router/index.routes";
import KTAPI from "../api/index.api";
import { ioSocket } from "../mm/index.mm";
import { errorMsg } from "./offscreen.controller.js";
import { _user } from "../classes/index.classes.js";

let observer = '';

const iStates =
{"STATE_DEAD": 0,
"STATE_WARMUP": 1,
"STATE_START": 2,
"STATE_FIRST_HALF": 3,
"STATE_HALFTIME": 4,
"STATE_SECOND_HALF": 5,
"STATE_OVERTIME": 6,
"STATE_END": 7,
"STATE_FAILED": 8}

const STATE_DEAD = 0;
const STATE_WARMUP = 1;
const STATE_START = 2;
const STATE_FIRST_HALF = 3;
const STATE_HALFTIME = 4;
const STATE_SECOND_HALF = 5;
const STATE_OVERTIME = 6;
const STATE_END = 7;
const STATE_FAILED = 8;

const szStates = ["No contest", "Warmup", "Setting Up", "First Half", "Halftime","Second Half", "Overtime", "Finished", "Failed"];

var myRadarArea;
var dot_t;
var dot_ct;

var mapdata = {
    de_dust2: {
        maporig:{x:-384.00,y:1120.00,z:224.00},
        imgorig:{x:-20,y:0,z:0},
        w: 550,
        h: 550
    },
    de_inferno: {
        maporig:{x:404.00,y:1312.00,z:297.00},
        imgorig:{x:0,y:0,z:0},
        w: 610,
        h: 610,
        
    },
    de_nuke: {
        maporig:{x:244.00,y:-936.00,z:-288.00},
        imgorig:{x:-4,y:0, z:0},
        w: 840,
        h: 1000,
        zlevel: -535,
    },
    de_train: {
        maporig:{x:32.00,y:156.00,z:28.00},
        imgorig:{x:0,y:0,z:0},
        w: 540,
        h: 506,
    },
    de_tuscan: {
        maporig:{x:-188.00,y:256.00,z:320.00},
        imgorig:{x:0,y:7,z:0},
        w: 520,
        h: 600,
    },
    de_mirage: {
        maporig:{x:-784.00,y:192.00,z:60.00},
        imgorig:{x:8,y:-2,z:0},
        w: 540,
        h: 460,
    },
    de_lite: {
        maporig:{x:-464.00,y:-1016.00,z:-64.00},
        imgorig:{x:14,y:10,z:0},
        w: 560,
        h: 530,
    }
};

var latestamp = 0;

var alive = [0,0,0,0];

const animateCSS = (element, animation, prefix = 'animate__') =>
// We create a Promise and return it
new Promise((resolve, reject) => {
    const animationName = `${prefix}${animation}`;
    const node = document.querySelector(element);

    node.classList.add(`${prefix}animated`, animationName);

    // When the animation ends, we clean the classes and resolve the Promise
    function handleAnimationEnd(event) {
    event.stopPropagation();
    //node.classList.remove(`${prefix}animated`, animationName);
    node.classList.remove(animationName);
    resolve('Animation ended');
    }

    node.addEventListener('animationend', handleAnimationEnd, {once: true});
});

const ROUND_NONE = 0;
const ROUND_TARGET_BOMB = 1;
const ROUND_VIP_ESCAPED = 2;
const ROUND_VIP_ASSASSINATED = 3;
const ROUND_TERRORISTS_ESCAPED = 4;
const ROUND_CTS_PREVENT_ESCAPE = 5;
const ROUND_ESCAPING_TERRORISTS_NEUTRALIZED= 6;
const ROUND_BOMB_DEFUSED= 7;
const ROUND_CTS_WIN= 8;
const ROUND_TERRORISTS_WIN= 9;
const ROUND_END_DRAW= 10;
const ROUND_ALL_HOSTAGES_RESCUED= 11;
const ROUND_TARGET_SAVED= 12;
const ROUND_HOSTAGE_NOT_RESCUED= 13;
const ROUND_TERRORISTS_NOT_ESCAPED= 14;
const ROUND_VIP_NOT_ESCAPED= 15;
const ROUND_GAME_COMMENCE= 16;
const ROUND_GAME_RESTART= 17;
const ROUND_GAME_OVER = 18;

const codeRoundResult = [
    "",
    `<img src="assets/media/weapons/C4-6 GO).png" class="img-fluid">`,
    "",
    "",
    "",
    "",
    "",
    `<img src="assets/media/weapons/defusekit.png" class="img-fluid">`,
    "",
    "",
    "",
    "",
    `<i class="fas fa-stopwatch text-white fs-4"></i>`,
    "",
    "",
    "",
    "",
    "",
    ""

]

let currentState = 0;
let currentRound = 0;
let livestream = {
    render: () => {
        
        return view;
    },
    after_render: async () => {
        animateImage(".img-adv",  ['fadeIn', 'bounce', 'pulse', 'fadeOut', 'zoomIn', 'tada', 'flip', 'rubberBand'], 
            ['2s', '2s', '3s', '2s', '2s', '2s', '2s', '2s'], true);
        let params = router.getCurrentLocation().params;
        //if(params.server)
        if(params == null || params.server === undefined || params.server == null)
        {
            alert("Bad url, streaming stopped");
            return;
        }

        if(!_user.authed)
        {
            //errorMsg({title: "Error", content: "You must be logged in to use a livestream"});
            alert("You must be logged in to use a livestream");
            return;
        }
        
        let liveinfo = await KTAPI.getLiveStreamInfo();
        //console.log(liveinfo);
        if(liveinfo.message == 'done')
        {
            if(liveinfo.info.list[params.server] === undefined)
            {
                alert("Server is not available for streaming");
                return;                
            }
            console.log(liveinfo.info.list[params.server]);
            
            observer = params.steamid || '';

            //initCanvas();
            //console.log(myRadarArea.canvas);
            //myRadarArea.start();
            //myRadarArea.drawmap('https://paradoxteam.org/fastdl/d2.png');

            currentState = liveinfo.info.list[params.server].state;
            renderOverlay(liveinfo.info.list[params.server]);

            ioSocket.socket.emit("livestream-subscribe",{server: params.server});
        }
        else
        {
            alert("No servers available for streaming");
            return;
        }

        $(".akros-app").remove();
        
        
    },
    root: true, 
    rerender: true,
    
};

function initCanvas()
{
    myRadarArea = {
        players: {},
        canvas : document.getElementById("ls-canvas"),
        start : function() {
            this.canvas.width = 386;
            this.canvas.height = 386;
            this.context = this.canvas.getContext("2d");
            this.last_timestamp = 0;
            dot_t = new Image();
            dot_t.src = "https://paradoxteam.org/fastdl/dot_t.png";
            dot_ct = new Image();
            dot_ct.src = "https://paradoxteam.org/fastdl/dot_ct.png";
            },
        drawmap : function(url,mapname = 'de_dust2') {
            let img = new Image();
            let self = this;
            $("#ls-canvas").attr("map",mapname);
            $(".ls-radar-img").attr("map",mapname);
            img.onload = function()
            {
                console.log("map loaded");
                self.context.drawImage(img, 0,0, self.canvas.width,self.canvas.height);
            }
            img.src = url;
        },
        drawplayer: function (data) {
            console.log(data.team);
            let self = this;
            if(data.team != 1 && data.team != 2) return;
            let map = $(".ls-radar-img").attr("map");
            console.log(map,mapdata[map]);
            if(mapdata[map] !== undefined)
            {
                let where = self.calccoord(data);
                console.log(where);
                //self.context.translate( where.x-25, where.y-25 );
                //self.context.rotate( (where.a > 0 ? where.a * -1 : 360 - where.a) * Math.PI/180);
                //self.context.drawImage( data.team == 1 ? dot_t : dot_ct, -25, -25 );
                //self.context.rotate( -((where.a > 0 ? where.a * -1 : 360 - where.a) * Math.PI/180) );
                //self.context.translate( -(where.x-25), -(where.y-25) );
                
                //self.context.save();
                //self.context.translate(where.x-25, where.y-25);
                //self.context.rotate((where.a > 0 ? where.a * -1 : 360 - where.a) * Math.PI/180);
                //self.context.translate(-25,-25);
                //self.context.drawImage(data.team == 1 ? dot_t : dot_ct,0,0);
                //self.context.restore();
                
                self.context.translate(where.x, where.y);                
                self.context.rotate((where.a > 0 ? where.a * -1 : 360 - where.a) * Math.PI/180);                            
                self.context.drawImage(data.team == 1 ? dot_t : dot_ct, - (data.team == 1 ? dot_t.width : dot_ct.width)/ 2, - (data.team == 1 ? dot_t.height : dot_ct.height)/ 2);                
                self.context.rotate(-((where.a > 0 ? where.a * -1 : 360 - where.a) * Math.PI/180));                            
                self.context.translate(-where.x, -where.y);
                
                //self.context.drawImage(data.team == 1 ? dot_t : dot_ct, where.x-25,where.y-25);
            }
        },
        calccoord: function (data) {
            let map = $(".ls-radar-img").attr("map");
            let res = {a: 0.0, x: 0.0, y: 0.0, z: 0.0};
            if(mapdata[map] !== undefined)
            {
                res.a = data.a;
                res.a = Math.round(res.a);

                res.x = data.x - mapdata[map].maporig.x;
                res.y = data.y - mapdata[map].maporig.y;
                res.z = data.z - mapdata[map].maporig.z;

                res.x = res.x / 8;
                res.y = res.y / 8;
                res.z = res.z / 8;

                res.x = res.x + 384;
                res.y = (res.y - 384) * -1;

                //res.x = Math.round(res.x / 2);
                //res.y = Math.round(res.y / 2);
                res.x = res.x / 2;
                res.y = res.y / 2;


                
            }
            return res;
        },
        
            
        
        clear : function() {
            this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
        }
    }
}


/**
 * 
 * SOCKET.IO PROCESSES
 * 
 */


const streamSocket = (socket) => {

    socket.on("livestream-error", async (data) => {

        console.log("[LIVESTREAM] error: ", data);
        errorMsg({title: "Livestream error", content: data.message});
    });
    
    socket.on("livestream-upd_server", async (data) => {
        if(data.map !== undefined)
        {
            renderRadar(data);
            return;
        }

        switch (data.action) {
            case 'newround': 
                console.log("[LIVESTREAM] new round: ", data);
                showPscores();
                renderTopBar(data);
                renderRoundWinner(data);
                break;
            case 'roundstart':
                console.log("[LIVESTREAM] round start: ", data);
                renderRoundHistory(data);
                hidePscores();
                break;
            case 'roundend':
                console.log("[LIVESTREAM] round end: ", data);
                renderRoundWinner(data);
                renderRoundHistory(data);
                break;

            case 'roundtimer':
                $(".livestream-overlay").find('.ls-round-timer').text(fancyTimeFormat(data.roundtime < 0 ? data.roundtime*-1 : data.roundtime));
                break;
            case 'matchevent':
                currentState = data.state;
                if(data.state == STATE_WARMUP) renderRoundHistory(data);
                $(".livestream-overlay").find('.ls-match-state').text(szStates[parseInt(data.state)]);
                break;

            case 'matchupdate':
                renderTopBar(data);
                break;
            
            case 'planted':
                renderTopBar(data);
                break;            
            case 'exploded':
                renderTopBar(data);
                break;
            case 'defused':
                renderTopBar(data);
                break;
            
            default:
                break;
        }
    });
    
    socket.on("livestream-upd_player", async (data) => {
        
        //console.log(data.sv);
        //if(router.getCurrentLocation().url.includes(data.sv.server)) updateLobby(data.sv);
        switch (data.action) {
            case 'connected':
                console.log("[LIVESTREAM] player connected: ", data);                
                renderPlayer(data);
                renderPlayerScore(data);
                renderFirstPerson(data);
                break;


            case 'disconnected':
                console.log("[LIVESTREAM] player disconnected: ", data);
                removePlayer({steamid: data.steamid});
                removePlayerScore({steamid: data.steamid});
                removeFirstPerson({steamid: data.steamid});
                break;

            case 'dead':
                renderPlayer(data);
                renderFirstPerson(data);
                break;
            case 'respawn':
                renderPlayer(data);
                renderFirstPerson(data);
                break;

            case 'team':
                removePlayer({steamid: data.steamid});
                renderPlayer(data);
                removePlayerScore({steamid: data.steamid});
                renderPlayerScore(data);
                removeFirstPerson({steamid: data.steamid});
                renderFirstPerson(data);
                break;

            case 'curweapon':                
                renderPlayer(data);                
                break;

            case 'health':
                renderPlayer(data);
                renderFirstPerson(data);
                break;
            case 'name':
                renderPlayer(data);
                renderFirstPerson(data);
                break;
            case 'bombpickup':
                renderPlayer(data);
                renderFirstPerson(data);
                break;
            case 'bombdrop':
                renderPlayer(data);
                renderFirstPerson(data);
                break;
            case 'defpickup':
                renderPlayer(data);
                renderFirstPerson(data);
                break;
            case 'defdrop':
                renderPlayer(data);
                renderFirstPerson(data);
                break;     
            case 'money':
                renderPlayer(data);
                renderFirstPerson(data);
                break;
            case 'kills':
                renderPlayer(data);
                renderPlayerScore(data);
                renderFirstPerson(data);
                break;
            case 'deaths':
                renderPlayer(data);
                renderPlayerScore(data);
                renderFirstPerson(data);
                break;
            case 'assists':
                renderPlayer(data);
                renderPlayerScore(data);
                renderFirstPerson(data);
                break;
            
            case 'kevlar':
                renderPlayer(data);
                renderFirstPerson(data);
                break;            
            case 'buynade':
                renderPlayer(data);
                renderFirstPerson(data);
                break;

            case 'pickdropweapon':
                renderPlayer(data);
                break;

            case 'obs_on':
                if(data.steamid == observer)
                {
                    if(data.obs == 1 && data.obswho !== '')
                    {
                        $(".ls-fp").addClass("d-none");
                        $(".livestream-overlay").find(`.ls-fp[data-steamid="${data.obswho}"]`).removeClass("d-none");
                    }
                }
                break;
            
            case 'obs_off':
                if(data.steamid == observer)
                {
                    if(data.obs == 0 || data.obswho === '')
                    {
                        $(".ls-fp").addClass("d-none");
                    }
                }

                break;
            
            case 'planting':
                renderTopBar(data);
                break;
            
            case 'planting_stop':
                renderTopBar(data);
                break;
            
            case 'defusing':
                renderTopBar(data);
                break;

            case 'defusing_stop':
                renderTopBar(data);
                break;
            
            default:
                break;
        }
        
    });
 
    socket.on("livestream-upd_frag", async (data) => {
        //console.log(data);
        renderKill(data);
    });

    socket.on("livestream-upd_radar", async (data) => {
        //console.log(data);
        if(data.timestamp)
        {
            if(data.timestamp <= latestamp)
            {
                return;
            }
            else
            {
                latestamp = data.timestamp;
                renderRadar(data);
            }
        }
        
    });

    socket.on("livestream-upd_alive", async (data) => {
        if(data == undefined || data == false) return;
        renderPlayersAlive(data);
    });

};

export {streamSocket};

/**
 * 
 * RENDER PROCESS
 * 
 */

function renderOverlay(data) {
    setInterval(() => {        
        if($(".pub-b").css("display") == "none")
        {            
            $(".pub-a").fadeOut(1000, ()=>{
                $(".pub-b").fadeIn(1000);
            });
        }
        if($(".pub-a").css("display") == "none")
        {            
            $(".pub-b").fadeOut(1000 , ()=>{
                $(".pub-a").fadeIn(1000);
            });
        }
    }, 10000);

    if(data.map) $(".livestream-overlay").find(".ls-map").text(data.map);
    if(data.players !== undefined)
    {        
        Object.keys(data.players).forEach(function(key, index) {
            if(data.players[key].connected == 1 && data.players[key].team > 0 && data.players[key].team < 3)
            {
                renderPlayer(data.players[key]);
                renderPlayerScore(data.players[key]);
                renderFirstPerson(data.players[key]);
                if(data.infreeze == 1)
                {
                    showPscores();
                }
                else{
                    hidePscores();
                }
                
                alive[data.players[key].team] += 1;
            }

        });

        renderPlayersAlive(alive);
    }

    renderTopBar(data);
    renderRadar(data);
    renderRoundHistory(data);
}

function renderRoundHistory(data)
{
    console.log("[LIVESTREAM] Render round history", data.action, currentRound);
    if(data.action == 'roundstart')
    {
        if(currentRound != 0){
            $(".livestream-overlay").find('.ls-round-history').removeClass("animate__fadeIn");
            animateCSS('.ls-round-history', 'fadeOut').then((message) => {
                $(".livestream-overlay").find('.ls-round-history').addClass("d-none");
            });
        }
        return;
    }

    if(data.action == 'roundend')
    {
        let round = data;
        let rounda = $(`.round-${round.round}-a`);
        let roundb = $(`.round-${round.round}-b`);
        let roundnum = $(`.round-${round.round}-num`);

        if(round.status == 1)
        {
            if(round.teamAside == 2)
            {
                rounda.removeClass("bg-white").removeClass("opacity-25").addClass("bg-zblue").html(codeRoundResult[round.event]);
                
            }
            if(round.teamBside == 2)
            {
                roundb.removeClass("bg-white").removeClass("opacity-25").addClass("bg-zblue").html(codeRoundResult[round.event]);
            }
        }
        if(round.status == 2)
        {
            if(round.teamAside == 1)
            {
                rounda.removeClass("bg-white").removeClass("opacity-25").addClass("bg-danger").html(codeRoundResult[round.event]);
            }
            if(round.teamBside == 1)
            {
                roundb.removeClass("bg-white").removeClass("opacity-25").addClass("bg-danger").html(codeRoundResult[round.event]);
            }                
        }
        return;
    }

    console.log("[LIVESTREAM] Render round history", data);
    //let roundEmpty = `<div class="d-table-cell"><span class="badge badge-circle w-25px h-25px bg-white opacity-25"></span></div>`;
           
    if(data.action == 'matchevent')
    {
        $(".livestream-overlay").find('.ls-round-history-a').empty();
        $(".livestream-overlay").find('.ls-round-history-b').empty();
        $(".livestream-overlay").find('.ls-round-history-number').empty();
        data.maxrounds = data.maxrounds || 30;
    }
    for(let i = 0; i < data.maxrounds; i++)
    {
        $(".livestream-overlay").find('.ls-round-history-a').append(`<div class="d-table-cell align-top"><span class="badge badge-circle h-30px w-30px bg-white opacity-25 round-${i+1}-a"></span></div>`);
        $(".livestream-overlay").find('.ls-round-history-b').append(`<div class="d-table-cell align-top"><span class="badge badge-circle h-30px w-30px bg-white opacity-25 round-${i+1}-b"></span></div>`);

        if(i == 0)
        { 
            $(".livestream-overlay").find('.ls-round-history-number').append(`<div class="d-table-cell"><div class="separator separator-content"><span class="text-gray-900 fw-semibold fs-6">${i+1}</span></div></div>`);
            continue;
        }
        if((i+1) % 5 == 0 && i != 0)
        {
            $(".livestream-overlay").find('.ls-round-history-number').append(`<div class="d-table-cell text-center fs-6 pt-4 pb-4"><div class="separator separator-content"><span class="text-gray-900 fw-semibold fs-5">${i+1}</span></div></div>`);
        }else
        {
            $(".livestream-overlay").find('.ls-round-history-number').append(`<div class="d-table-cell"><div class="separator w-100"></div></div>`);
        }
    }

    let rounds = data.rounds;        
    if(rounds.length == 0) return;
    for(let i = 0; i < rounds.length; i++)
    {
        if(rounds[i].round == 0) continue;
        console.log("[LIVESTREAM] Round history", rounds[i]);
        let round = rounds[i];
        let rounda = $(`.round-${round.round}-a`);
        let roundb = $(`.round-${round.round}-b`);
        let roundnum = $(`.round-${round.round}-num`);
        
        if(round.status == 1)
        {
            if(round.teamAside == 2)
            {
                rounda.removeClass("bg-white").removeClass("opacity-25").addClass("bg-zblue").html(codeRoundResult[round.event]);
                
            }
            if(round.teamBside == 2)
            {
                roundb.removeClass("bg-white").removeClass("opacity-25").addClass("bg-zblue").html(codeRoundResult[round.event]);
            }
        }
        if(round.status == 2)
        {
            if(round.teamAside == 1)
            {
                rounda.removeClass("bg-white").removeClass("opacity-25").addClass("bg-danger").html(codeRoundResult[round.event]);
            }
            if(round.teamBside == 1)
            {
                roundb.removeClass("bg-white").removeClass("opacity-25").addClass("bg-danger").html(codeRoundResult[round.event]);
            }                
        }
    }
    
}

function renderRoundWinner(data)
{
    if(data.action == 'newround')
    {
        if(currentRound != 0){
        $(".livestream-overlay").find('.ls-round-winner').removeClass("animate__flipInX");
        animateCSS('.ls-round-winner', 'flipOutX').then((message) => {
            $(".livestream-overlay").find('.ls-round-winner').addClass("d-none");
            $(".livestream-overlay").find('.ls-round-history').addClass("animate__fadeIn").removeClass("d-none");
        });
        }
        return;
    }
    let winnerTeam = '';
    if(data.teamAside <= 1)
    {
        winnerTeam = data.status == 2 ? (data.teamAname == '' ? 'TEAM A' : data.teamAname) : (data.teamBname == '' ? 'TEAM B' : data.teamBname);
    }
    if(data.teamAside == 2)
    {
        winnerTeam = data.status == 1 ? (data.teamAname == '' ? 'TEAM A' : data.teamAname) : (data.teamBname == '' ? 'TEAM B' : data.teamBname);
    }
    

    $(".livestream-overlay").find('.ls-round-winner-name').removeClass("bg-danger").removeClass("bg-info").addClass(data.status == 1 ? "bg-info" : (data.status == 2 ? "bg-danger" : "")).text(winnerTeam);
    $(".livestream-overlay").find('.ls-round-winner').removeClass("animate__flipOutX").addClass("animate__flipInX").removeClass("d-none");    
}

function renderPlayersAlive(data)
{
    console.log("[LIVESTREAM] Render players alive", data);
    $(".livestream-overlay").find('.ls-players-alive').find('.ls-t-players').text(data[1]);
    $(".livestream-overlay").find('.ls-players-alive').find('.ls-ct-players').text(data[2]);
}


function renderRadar(data){

    let map = data.map  || $(".ls-radar-img").attr("map");

    if(data.map !== undefined && $(".ls-radar-img").attr("map") != data.map)
    {        
        //myRadarArea.drawmap("assets/media/maps/minimap/"+data.map+".png", data.map);
        $(".ls-radar-img").find("img").attr("src", `https://paradoxteam.org/fastdl/${data.map}.png`);
        $(".ls-radar-img").attr("map", data.map);
        $(".livestream-overlay").find(".ls-map").text(data.map);
        
    }
    //console.log("[LIVESTREAM] Render radar");
    let pls = [];
    if(data.players !== undefined && Object.keys(data.players).length)
    {
        Object.keys(data.players).forEach(function(key, index) {
            if(key !== "HLTV")
            {
                buildDot(data.players[key]);
                pls.push(key);
            }
            
        });                
    }

    if(data.players !== undefined)
    {
        $(".radar-dot").each(function() {
            if(!pls.includes($(this).attr("steam")))
            {
                $(this).remove();
            }
        });
    }

    

    function buildDot(data)
    {     
        if(data.team != 0 || data.team != 3 || data.steamid !== "HLTV")
        {
            if(!$(`.radar-dot[steam="${data.steamid}"]`).length)
            {
                let pos = calc_coord(data);
                let dot = `<div class="radar-dot d-block position-absolute smooth rounded overflow-hidden ${data.dead == 1 ? 'd-none' : ''}" steam="${data.steamid}" style="padding:2px;top:${pos.y-12}px;left:${pos.x-12}px;/*transform: rotate(${pos.a}deg);*/${data.team == 1 ? 'background: #fd1d1d' : 'background: #6f1eff'}">
                    <!--<img src="https://paradoxteam.org/fastdl/dot_${data.team == 1 ? 't' : 'ct'}.png">-->
                    <div class="symbol symbol-20px">
                        <img src="${data.avatar === undefined ? "assets/media/avatars/default.jpg" : data.avatar}" class="" alt="">
                    </div>
                </div>`;

                $(".ls-radar-img").append(dot);
            }
            else
            {            
                let pos = calc_coord(data);
                if(!data.steamid.includes("BOT")) {
                    //console.log(pos);
                    //console.log("team-> ",data.team);
                }
                if(data.dead == 1)
                {
                    $(`.radar-dot[steam="${data.steamid}"]`).addClass("d-none");
                }
                else
                {
                    
                    if(data.team == 1)
                    {
                        $(`.radar-dot[steam="${data.steamid}"]`).removeClass("d-none");
                        $(`.radar-dot[steam="${data.steamid}"]`).css("background", "#fd1d1d");                    
                    }else if(data.team == 2)
                    {
                        $(`.radar-dot[steam="${data.steamid}"]`).removeClass("d-none");
                        $(`.radar-dot[steam="${data.steamid}"]`).css("background", "#6f1eff");
                    }
                    else
                    {
                        $(`.radar-dot[steam="${data.steamid}"]`).addClass("d-none");
                    }
                }
                               

                $(`.radar-dot[steam="${data.steamid}"]`).css("left", `${pos.x-12}px`).css("top", `${pos.y-12}px`);//.css("transform", `rotate(${pos.a}deg)`);
            }
        }
    }

    function calc_coord(data) {
        let map = $(".ls-radar-img").attr("map");
        let res = {a: 0.0, x: 0.0, y: 0.0, z: 0.0};
        if(mapdata[map] !== undefined)
        {
            res.a = data.a;
            res.a = Math.round(res.a);

            res.a = data.a > 0 ? 360 - data.a : 360 + data.a;

            res.x = data.x - mapdata[map].maporig.x;
            res.y = data.y - mapdata[map].maporig.y;
            res.z = data.z - mapdata[map].maporig.z;

            res.x = res.x / 8; //unidades a pixeles
            res.y = res.y / 8;
            res.z = res.z / 8;

            res.x =  res.x + (mapdata[map].w/2) + mapdata[map].imgorig.x;

            if(map !== 'de_nuke')
            {                                                
                res.y = (res.y - (mapdata[map].h/2 + mapdata[map].imgorig.y)) * -1;
            }
            else
            {
                if(data.z > mapdata[map].zlevel)
                {                                        
                    res.y = (res.y - (mapdata[map].h/4 + mapdata[map].imgorig.y)) * -1;                   
                }
                else
                {
                    res.y = (res.y - (mapdata[map].h*3/4 + mapdata[map].imgorig.y)) * -1;                    
                }
            }               
            res.x = $(".ls-radar-img").width() * res.x / mapdata[map].w;
            res.y = $(".ls-radar-img").height() * res.y / mapdata[map].h;

        }
        return res;
    }
}

/*function renderRadar(data){
    
    myRadarArea.clear();
    if(data.map !== undefined && $(".ls-radar-img").attr("map") != data.map)
    {        
        //myRadarArea.drawmap("assets/media/maps/minimap/"+data.map+".png", data.map);
        
    }
    //console.log(data.players);
    if(data.players !== undefined && Object.keys(data.players).length)
    {
        Object.keys(data.players).forEach(function(key, index) {
            myRadarArea.drawplayer(data.players[key]);
            
        });
        
    }
}*/

function renderTopBar(data)
{
    if(data.action == 'newround')
    {
        $(".livestream-overlay").find('.ls-bomb-planting').addClass("d-none");
        $(".livestream-overlay").find('.ls-team-t-name').removeClass("d-none");
        
        $(".livestream-overlay").find('.ls-bomb-defusing').addClass("d-none");
        $(".livestream-overlay").find('.ls-team-ct-name').removeClass("d-none");
        
        $(".livestream-overlay").find('.ls-bomb-defused').addClass("d-none");
        $(".livestream-overlay").find('.ls-defuser-timer').addClass("d-none");

        $(".livestream-overlay").find('.ls-bomb-planted').addClass("d-none");
        $(".livestream-overlay").find('.ls-bomb-timer').addClass("d-none");
        $(".livestream-overlay").find('.ls-state-container').removeClass("d-none");

       

        
        
                
        return;
    }
    if(data.action == 'planting')
    {
        console.log("[LIVESTREAM] Planting", data);
        $(".livestream-overlay").find('.planting-name').text(`${data.nick}`);
        $(".livestream-overlay").find('.ls-team-t-name').addClass("d-none");
        $(".livestream-overlay").find('.ls-bomb-planting').removeClass("animate__flipOutX").addClass("animate__flipInX").removeClass("d-none");;       
        return;
    }

    if(data.action == 'planting_stop' || data.action == 'planted')
    {
        console.log("[LIVESTREAM] Planting stop", data);
        $(".livestream-overlay").find('.ls-bomb-planting').removeClass("animate__flipInX");
        animateCSS('.ls-bomb-planting', 'flipOutX').then((message) => {
            $(".livestream-overlay").find('.ls-bomb-planting').addClass("d-none");
            $(".livestream-overlay").find('.ls-team-t-name').removeClass("d-none");
        });

        if(data.action == 'planted')
        {   
            console.log("[LIVESTREAM] Bomb planted", data);
            $(".livestream-overlay").find('.ls-state-container').addClass("d-none");
            $(".livestream-overlay").find('.ls-bomb-defused').addClass("d-none");
            $(".livestream-overlay").find('.ls-bomb-planted').removeClass("animate__flipOutX").addClass("animate__flipInX").removeClass("d-none");

            $(".livestream-overlay").find('.ls-site-planted').text(data.site == 1 ? "A site" : (data.site == 2 ? "B site" : ""));
            
            $(".livestream-overlay").find('.ls-bomb-timer .progress-bar').addClass("reduce");
            
            $(".livestream-overlay").find('.ls-bomb-timer .progress-bar').off('animationend');
            $(".livestream-overlay").find('.ls-bomb-timer .progress-bar').one('animationend', function(e) {
                e.preventDefault();
                $(".livestream-overlay").find('.ls-bomb-timer .progress-bar').removeClass("reduce");
                $(".livestream-overlay").find('.ls-bomb-timer .progress-bar').css("width", "0%");
            });

            $(".livestream-overlay").find('.ls-bomb-timer').removeClass("animate__fadeOutUp").addClass("animate__fadeInDown").removeClass("d-none");


            $(".livestream-overlay").find('.ls-defuser-timer .progress-bar').off('animationend');
            $(".livestream-overlay").find('.ls-defuser-timer .progress-bar').one('animationend', function(e) {
                e.preventDefault();
                $(".livestream-overlay").find('.ls-defuser-timer .progress-bar').removeClass("no-kit").removeClass("kit");
                $(".livestream-overlay").find('.ls-defuser-timer .progress-bar').css("width", "0%");                
                
            });
                       
        }
                
        return;
    }
    if(data.action == 'defusing')
    {
        console.log("[LIVESTREAM] Defusing", data);
        $(".livestream-overlay").find('.defusing-name').text(`${data.nick}`);
        $(".livestream-overlay").find('.ls-team-ct-name').addClass("d-none");        

        $(".livestream-overlay").find('.ls-bomb-defusing').removeClass("animate__flipOutX").addClass("animate__flipInX").removeClass("d-none");

        $(".livestream-overlay").find('.ls-defuser-timer .progress-bar').removeClass("no-kit").removeClass("kit").addClass(data.def == 1 ? "kit" : "no-kit");
        $(".livestream-overlay").find('.ls-defuser-timer').removeClass("animate__fadeOutUp").addClass("animate__fadeInDown").removeClass("d-none");

        return;
    }
    if(data.action == 'defusing_stop' || data.action == 'defused')
    {
        console.log("[LIVESTREAM] Defusing stop", data);
        $(".livestream-overlay").find('.ls-bomb-defusing').removeClass("animate__flipInX");
        animateCSS('.ls-bomb-defusing', 'flipOutX').then((message) => {
            $(".livestream-overlay").find('.ls-bomb-defusing').addClass("d-none");
            $(".livestream-overlay").find('.ls-team-ct-name').removeClass("d-none");
        });

        if(data.action == 'defusing_stop')
        {
            $(".livestream-overlay").find('.ls-defuser-timer').removeClass("animate__fadeInDown");
            animateCSS('.ls-defuser-timer', 'fadeOutUp').then((message) => {
                $(".livestream-overlay").find('.ls-defuser-timer').addClass("d-none");
                $(".livestream-overlay").find('.ls-defuser-timer .progress-bar').removeClass("no-kit").removeClass("kit");                
            });
        }

        if(data.action == 'defused')
        {   
            console.log("[LIVESTREAM] Bomb defused", data);
            $(".livestream-overlay").find('.ls-bomb-planted').addClass("d-none");
            $(".livestream-overlay").find('.ls-bomb-defused').removeClass("d-none");

            $(".livestream-overlay").find('.ls-bomb-timer .progress-bar').removeClass("reduce");
            $(".livestream-overlay").find('.ls-bomb-timer .progress-bar').css("width", "0%");
            
        }

        return;
    }
    if(data.action == 'exploded')
    {
        return;
    }
   

    let tname = 'TEAM_A';
    let ctname = 'TEAM_B';

    if(data.teamAside == 1)
    {
        tname = data.teamAname;
        ctname = data.teamBname;
    }
    else{
        ctname = data.teamAname;
        tname = data.teamBname;
    }

    $(".livestream-overlay").find('.ls-team-t-name').text(tname);
    $(".livestream-overlay").find('.ls-team-ct-name').text(ctname);

    $(".livestream-overlay").find('.ls-team-t-score').text(data.tscore);
    $(".livestream-overlay").find('.ls-team-ct-score').text(data.ctscore);

    currentRound = parseInt(data.round);
    $(".livestream-overlay").find('.ls-round').text((parseInt(data.round)+1)+"/"+data.maxrounds);
    $(".livestream-overlay").find('.ls-round-timer').text(fancyTimeFormat(data.roundtime));

    if(data.state)
    {
        $(".livestream-overlay").find('.ls-match-state').text(szStates[parseInt(data.state)]);
    }
    if(data.event)
    {
        $(".livestream-overlay").find('.ls-event').text(data.event);
    }
    
}

let kfn = 0;
function renderKill(data) {

    if(data.weapon == 6) return;

    if($('.kf-notice').length > 4)
    {
        $("#kf-"+(kfn-5)).remove();
    }

    let id = `kf-${kfn}`
    
    let sk = `<div class="h-30px">
        <img class="h-100 mirror" src="assets/media/icons/smokekill.png">
    </div>`;
    let hs = `<div class="h-25px">
        <img class="h-100" src="assets/media/icons/hskill.png">
    </div>`;
    let wb = `<div class="h-30px">
        <img class="h-100" src="assets/media/icons/wbkill.png">
    </div>`;
    let blind = `<span class="h-30px">
        <img class="h-100" src="assets/media/icons/blindperson.png">
    </span>`;
    let dead = `<div class="h-25px">
        <img class="h-100" src="assets/media/icons/dead.png">
    </div>`;
    let ns = `<div class="h-30px">
        <img class="h-100" src="assets/media/icons/noscopekill.png">
    </div>`;
    let qs = `<div class="h-30px">
        <img class="h-100" src="assets/media/icons/quickscope.png">
    </div>`;
    
    


    /*let html = `
        <div id="${id}" class="d-flex gap-2 align-items-center justify-content-end px-3 py-1 bg-zblack bg-opacity-75 mb-2 kf-notice min-h-35px rounded">
            <div class="d-flex flex-nowrap gap-1">${data.blind_killer == 1 ? blind : ''}<span class="${data.killer_team == 1 ? 'text-danger' : 'text-zblue'} fs-4 fw-bold">${data.killer_nick}</span>${data.assistant !== '' ? ` + <span class="${data.assistant_team == 1 ? 'text-danger' : 'text-zblue'} fs-4 fw-bold">${data.assistant_nick}</span>`: ""}${data.flashassistant !== '' ? ` + <span class="h-25px"><img class="h-100" src="assets/media/icons/fbassist.png"/></span><span class="${data.flashassistant_team == 1 ? 'text-danger' : 'text-zblue'}">${data.flashassistant_nick}</span>`: ""}</div>
            <div class="text-white d-flex align-items-center ls-kf-icons">
                ${data.suicide == 1 ? dead : `<div class="h-30px">
                    <img class="h-100 mirror" src="assets/media/weapons/${data.weapon}.png">
                </div>`}
                ${data.noscope ? (data.noscope == 1 ? ns : qs): ''}
                ${data.smokekill == 1 ? sk: ''}
                ${data.wallbang == 1 ?  wb: ''}
                ${data.headshot == 1 ?  hs: ''}
            </div>
            <div class="${data.victim_team == 1 ? 'text-danger' : 'text-zblue'} fs-4 fw-bold">${data.victim_nick}</div>
        </div>
    `;*/

    let html = /* html */`
        <div id="${id}" class="d-flex gap-2 align-items-center justify-content-end bg-zblack bg-opacity-75 mb-2 kf-notice min-h-35px rounded overflow-hidden animate__animated animate__fadeInDown kf-notice-element">
            <div class="d-flex flex-nowrap align-items-center gap-1 py-1 px-3 h-100" style="${data.killer_team == 1 ? 'background: rgb(253,29,29);' : 'background: rgb(111,30,255);'}">${data.blind_killer == 1 ? blind : ''}<span class="text-white fs-4 fw-bold">${data.killer_nick}</span>${data.assistant !== '' ? ` + <span class="text-white fs-4 fw-bold">${data.assistant_nick}</span>`: ""}${data.flashassistant !== '' ? ` + <span class="h-30px"><img class="h-100" src="assets/media/icons/fbassist.png"/></span><span class="text-white fs-4">${data.flashassistant_nick}</span>`: ""}</div>
            <div class="text-white d-flex align-items-center ls-kf-icons py-1">
                ${data.suicide == 1 ? dead : `<div class="h-30px">
                    <img class="h-100 mirror" src="assets/media/weapons/${data.weapon}.png">
                </div>`}
                ${data.noscope ? (data.noscope == 1 ? ns : qs): ''}
                ${data.smokekill == 1 ? sk: ''}
                ${data.wallbang == 1 ?  wb: ''}
                ${data.headshot == 1 ?  hs: ''}
            </div>
            <div class="d-flex flex-nowrap align-items-center text-white fs-4 fw-bold py-1 px-3 h-100" style="${data.victim_team == 1 ? 'background: rgb(253,29,29);' : 'background: rgb(111,30,255);'}">${data.victim_nick}</div>
        </div>
    `;

    //prevent duplicates

    html = $(html);
    let txt = html.html();

    let renderkf = true;

    $(".ls-kf").find(".kf-notice-element").each(function(){

        let tmptxt = $(this).html();
        //console.log(txt);
        //console.log(tmptxt);
        if(txt === tmptxt)
        {
            renderkf = false;
        }

    });     

    if(renderkf) $(".livestream-overlay").find(".ls-kf").append(html);
    //

    setTimeout(() => {
        //console.log("fade -> ", id);
        //$("#"+id).fadeOut(1000,function(){
        //  if($("#"+id).length) $("#"+id).remove();
        //});
        $("#"+id).addClass("kf-notice-del").removeClass("animate__fadeInDown").addClass("animate__fadeOutUp");
    }, 5000);

    kfn++;
}

$(document).ready(function(){
    $(document).on("animationend", ".kf-notice-del", function(e) {
        $(this).remove();
    });

    $("video").each(function() {
        var $source = $(this).find('source');
        var src = $source.attr('data-src');
        
        $source.removeAttr('data-src');
        $source.attr('src', src);
        $source.detach().appendTo($(this))
        
        $(this).get(0).play();
    });
});

function renderFirstPerson(data) {
    if($(".livestream-overlay").find(`.ls-fp[data-steamid="${data.steamid}"]`).length)
    {
        if(data.action == 'health')
        {            
            $(".livestream-overlay").find(`.ls-fp[data-steamid="${data.steamid}"]`).find(".ls-hpp").text(data.hp);
            $(".livestream-overlay").find(`.ls-fp[data-steamid="${data.steamid}"]`).find(".ls-armor").text(data.armor);
        }
        else if(data.action == 'name')
        {
            $(".livestream-overlay").find(`.ls-fp[data-steamid="${data.steamid}"]`).find(".ls-nick").text(data.nick === undefined ? data.steamid.replace("BOT:", "") : data.nick);
        }        
        else if(data.action == 'bombdrop')
        {
            $(".livestream-overlay").find(`.ls-fp[data-steamid="${data.steamid}"]`).find(".ls-hasc4").addClass("d-none");
        }
        else if(data.action == 'bombpickup')
        {
            $(".livestream-overlay").find(`.ls-fp[data-steamid="${data.steamid}"]`).find(".ls-hasc4").removeClass("d-none");
        }
        else if(data.action == 'defdrop')
        {
            $(".livestream-overlay").find(`.ls-fp[data-steamid="${data.steamid}"]`).find(".ls-hasdef").addClass("d-none");
        }
        else if(data.action == 'defpickup')
        {
            $(".livestream-overlay").find(`.ls-fp[data-steamid="${data.steamid}"]`).find(".ls-hasdef").removeClass("d-none");
        }        
        else if(data.action == 'kills')
        {
            $(".livestream-overlay").find(`.ls-fp[data-steamid="${data.steamid}"]`).find(".ls-kills").text(data.kills);
        }
        else if(data.action == 'deaths')
        {
            $(".livestream-overlay").find(`.ls-fp[data-steamid="${data.steamid}"]`).find(".ls-deaths").text(data.deaths);
        }
        else if(data.action == 'assists')
        {
            $(".livestream-overlay").find(`.ls-fp[data-steamid="${data.steamid}"]`).find(".ls-assists").text(data.assists);
        }
        else if(data.action == 'kevlar')
        {            
            if(data.kev == 0 || data.kev == 1){                
                $(".livestream-overlay").find(`.ls-fp[data-steamid="${data.steamid}"]`).find(".ls-vesthelm").addClass("d-none");
                $(".livestream-overlay").find(`.ls-fp[data-steamid="${data.steamid}"]`).find(".ls-vest").removeClass("d-none");
            }
            if(data.kev == 2){                
                $(".livestream-overlay").find(`.ls-fp[data-steamid="${data.steamid}"]`).find(".ls-vest").addClass("d-none");
                $(".livestream-overlay").find(`.ls-fp[data-steamid="${data.steamid}"]`).find(".ls-vesthelm").removeClass("d-none");
            }
        }
        else if (data.action == 'buynade') {
            if (data.he > 0) {
                $(".livestream-overlay").find(`.ls-fp[data-steamid="${data.steamid}"]`).find(".ls-he").removeClass("d-none")
            } else {
                $(".livestream-overlay").find(`.ls-fp[data-steamid="${data.steamid}"]`).find(".ls-he").addClass("d-none")
            }

            if (data.fb > 0) {
                if (data.fb == 1) {
                    $(".livestream-overlay").find(`.ls-fp[data-steamid="${data.steamid}"]`).find(".ls-fb-2").addClass("d-none")
                    $(".livestream-overlay").find(`.ls-fp[data-steamid="${data.steamid}"]`).find(".ls-fb-1").removeClass("d-none");
                }
                if (data.fb == 2) {
                    $(".livestream-overlay").find(`.ls-fp[data-steamid="${data.steamid}"]`).find(".ls-fb-2").removeClass("d-none")
                    $(".livestream-overlay").find(`.ls-fp[data-steamid="${data.steamid}"]`).find(".ls-fb-1").removeClass("d-none");
                }
            } else {
                $(".livestream-overlay").find(`.ls-fp[data-steamid="${data.steamid}"]`).find(".ls-fb-2").addClass("d-none")
                $(".livestream-overlay").find(`.ls-fp[data-steamid="${data.steamid}"]`).find(".ls-fb-1").addClass("d-none");
            }

            if (data.sg > 0) {
                $(".livestream-overlay").find(`.ls-fp[data-steamid="${data.steamid}"]`).find(".ls-sg").removeClass("d-none")
            } else {
                $(".livestream-overlay").find(`.ls-fp[data-steamid="${data.steamid}"]`).find(".ls-sg").addClass("d-none")
            }
            
        } else if (data.action == 'dead') {
            $(".livestream-overlay").find(`.ls-fp[data-steamid="${data.steamid}"]`).find(".ls-hpp").text("0");
            $(".livestream-overlay").find(`.ls-fp[data-steamid="${data.steamid}"]`).find(".ls-armor").text("0");
        } 

    }
    else
    {
        buildFirstPerson(data);
    }

    function buildFirstPerson(data) {
        if(data.team > 0 && data.team < 3){
            let html = /* html */`            
                <div class="card-body p-0 d-flex align-items-center justify-content-between" style="min-height:38px">
                    <div class="d-flex px-3" style="width:40%">
                        <div class="d-flex align-items-center">
                            <div class="w-25px me-2"><img class="w-100" src="assets/media/flags/${data.flag === undefined ? "" : data.flag}.gif" class="" alt=""></div>
                            <div class="d-flex">
                                <span class="text-white fw-bolder text-hover-white fs-3 text-uppercase lh-2 text-nowrap text-truncate mw-150px ls-nick">${data.nick === undefined ? data.steamid.replace("BOT:", "") : data.nick}</span>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex" style="width:20%">
                    </div>
                    <div class="d-flex" style="width:40%">
                        <div class="d-flex align-items-center justify-content-center w-100 gap-3">                            
                            <div class="d-flex align-items-center justify-content-center w-35px">                                  
                                <div class="ls-hasc4 h-35px py-1 ${data.bomb === undefined || data.bomb == 0 ? "d-none" : ""}">
                                    <img class="h-100" src="assets/media/weapons/6.png"/>
                                </div>
                                <div class="ls-hasdef h-35px py-1 ${data.def === undefined || data.def == 0 ? "d-none" : ""}">
                                    <img class="h-100" src="assets/media/weapons/defusekit.png"/>
                                </div>                                                      
                            </div>
                            

                            <div class="d-flex align-items-center ls-nades">
                                <div class="d-flex gap-1 align-items-center justify-content-center h-35 py-1 fs-5">
                                    <span class="h-30px ls-he ${data.he == 1 ? '' : 'd-none'}"><img class="h-100" src="assets/media/weapons/4.png"/></span>
                                    <span class="h-30px ls-fb-1 ${data.fb == 1 || data.fb == 2 ? '' : 'd-none'}"><img class="h-100" src="assets/media/weapons/25.png"/></span>
                                    <span class="h-30px ls-fb-2 ${data.fb == 2 ? '' : 'd-none'}"><img class="h-100" src="assets/media/weapons/25.png"/></span>
                                    <span class="h-30px ls-sg ${data.sg == 1 ? '' : 'd-none'}"><img class="h-100" src="assets/media/weapons/9.png"/></span>
                                </div>
                            </div>

                        </div>
                    </div>                                       
                </div>

                <div class="card-footer p-0 d-flex align-items-center justify-content-between" style="min-height:38px;${data.team == 1 ? 'background: rgb(253,29,29);' : 'background: rgb(111,30,255);'}">
                    <div class="d-flex px-3 gap-4" style="width:40%">                        
                        <div class="d-flex align-items-center">                            
                            <div class="symbol symbol-30px">
                                <div class="symbol-label bg-transparent">                                    
                                    <i class="fad fa-notes-medical fs-2 text-white"></i>
                                </div>
                            </div>                            
                            <div>
                                <div class="fs-2 text-gray-900 ls-hpp text-center">${data.hp}</div>                
                            </div>                            
                        </div>
                        <div class="d-flex align-items-center">                            
                            <div class="symbol symbol-30px">
                                <div class="symbol-label bg-transparent">                                    
                                    <div class="h-30px py-1">
                                        <img class="h-100 ls-vest ${data.kev == 1 || data.kev == 0? "" : "d-none"}" src="assets/media/weapons/31.png"/>
                                        <img class="h-100 ls-vesthelm ${data.kev == 2 ? "" : "d-none"}" src="assets/media/weapons/32.png"/>
                                    </div>
                                </div>
                            </div>                            
                            <div>
                                <div class="fs-2 text-gray-900 ls-armor text-center">${data.armor}</div>                
                            </div>                            
                        </div>
                        
                    </div>
                    <div class="d-block position-relative" style="width:20%;height:100%;">                        
                        <div class="position-absolute w-100px h-100px me-2 rounded overflow-hidden bottom-0" style="left: 0;right: 0;margin-left: auto;
                        margin-right: auto;"><img class="w-100" src="${data.avatar === undefined ? "assets/media/avatars/default.jpg" : data.avatar}" class="" alt=""></div>
                    </div>
                    <div class="d-flex" style="width:40%">
                        <div class="d-flex align-items-center justify-content-center w-100">
                            <div class="d-flex flex-row justify-content-between gap-3">
                                
                                <div class="d-flex align-items-center">
                                    <!--begin::Symbol-->
                                    <div class="symbol symbol-30px me-1">
                                        <div class="symbol-label bg-transparent">
                                            <i class="fad fa-crosshairs fs-2 text-white"></i>
                                        </div>
                                    </div>
                                    <!--end::Symbol-->
                                    <!--begin::Title-->
                                    <div>
                                        <div class="fs-4 text-dark fw-bold lh-2 ls-kills">${data.kills}</div>
                                        <!--<div class="fs-5 text-primary fw-bolder lh-4 text-nowrap">K</div>-->
                                    </div>
                                    <!--end::Title-->
                                </div>

                                <div class="d-flex align-items-center">
                                    <!--begin::Symbol-->
                                    <div class="symbol symbol-30px me-1">
                                        <div class="symbol-label bg-transparent">
                                            <i class="fad fa-hands-helping fs-2 text-white"></i>
                                        </div>
                                    </div>
                                    <!--end::Symbol-->
                                    <!--begin::Title-->
                                    <div>
                                        <div class="fs-4 text-dark fw-bold lh-2 ls-assists">${data.assists}</div>
                                        <!--<div class="fs-5 text-primary fw-bolder lh-1 text-nowrap">A</div>-->
                                    </div>
                                    <!--end::Title-->
                                </div>

                                <div class="d-flex align-items-center">
                                    <!--begin::Symbol-->
                                    <div class="symbol symbol-30px me-1">
                                        <div class="symbol-label bg-transparent">
                                            <i class="fad fa-skull fs-2 text-white"></i>
                                        </div>
                                    </div>
                                    <!--end::Symbol-->
                                    <!--begin::Title-->
                                    <div>
                                        <div class="fs-4 text-dark fw-bold lh-2 ls-deaths">${data.deaths}</div>
                                        <!--<div class="fs-5 text-primary fw-bolder lh-1 text-nowrap">D</div>-->
                                    </div>
                                    <!--end::Title-->
                                </div>
                                
                            </div>
                        </div>
                    </div>                    
                </div>                
            `;

            if($(".livestream-overlay").find(`.ls-fp[data-steamid="${data.steamid}"]`).length)
            {
                $(".livestream-overlay").find(`.ls-fp[data-steamid="${data.steamid}"]`).html(`${html}`);
            }
            else
            {
                $(".livestream-overlay").find('.ls-firstperson').append(`<div class="card my-0 mx-0 ls-fp card-flush rounded w-100 d-none" data-steamid="${data.steamid}" style="background-color: rgba(31,31,31,0.85);">${html}</div>`);
            }
            
        }
    }
}
function removeFirstPerson(data){    
    if($(".livestream-overlay").find(`.ls-fp[data-steamid="${data.steamid}"]`).length)
    {
        $(".livestream-overlay").find(`.ls-fp[data-steamid="${data.steamid}"]`).remove();
    }
}

function removePlayer(data){
    if($(".livestream-overlay").find(`.ls-slot[data-steamid="${data.steamid}"]`).length)
    {
        $(".livestream-overlay").find(`.ls-slot[data-steamid="${data.steamid}"]`).remove();
    }
}

function renderPlayerScore(data){
    if($(".livestream-overlay").find(`.ls-pscore[data-steamid="${data.steamid}"]`).length)
    {
        if(data.action == 'kills')
        {
            $(".livestream-overlay").find(`.ls-pscore[data-steamid="${data.steamid}"]`).find(".ls-kills").text(data.kills);
        }
        if(data.action == 'deaths')
        {
            $(".livestream-overlay").find(`.ls-pscore[data-steamid="${data.steamid}"]`).find(".ls-deaths").text(data.deaths);
        }
        if(data.action == 'assists')
        {
            $(".livestream-overlay").find(`.ls-pscore[data-steamid="${data.steamid}"]`).find(".ls-assists").text(data.assists);
        }
    }
    else
    {
        buildPlayerScore(data);
    }

    function buildPlayerScore(data) {
        if(data.team > 0 && data.team < 3){  
            let html = /* html */`            
                <div class="card-body p-0 card-body p-0 d-flex align-items-center justify-content-center" style="min-height:76px">
                    <div class="d-flex align-items-center justify-content-center">
                        <div class="d-flex flex-row justify-content-between gap-8">
                            
                            <div class="d-flex align-items-center">
                                <!--begin::Symbol-->
                                <div class="symbol symbol-30px me-2">
                                    <div class="symbol-label bg-transparent">
                                        <i class="fad fa-crosshairs fs-1 text-danger"></i>
                                    </div>
                                </div>
                                <!--end::Symbol-->
                                <!--begin::Title-->
                                <div>
                                    <div class="fs-4 text-dark fw-bold lh-2 ls-kills">${data.kills}</div>
                                    <div class="fs-5 text-primary fw-bolder lh-1 text-nowrap">K</div>
                                </div>
                                <!--end::Title-->
                            </div>

                            <div class="d-flex align-items-center">
                                <!--begin::Symbol-->
                                <div class="symbol symbol-30px me-2">
                                    <div class="symbol-label bg-transparent">
                                        <i class="fad fa-hands-helping fs-1 text-white"></i>
                                    </div>
                                </div>
                                <!--end::Symbol-->
                                <!--begin::Title-->
                                <div>
                                    <div class="fs-4 text-dark fw-bold lh-2 ls-assists">${data.assists}</div>
                                    <div class="fs-5 text-primary fw-bolder lh-1 text-nowrap">A</div>
                                </div>
                                <!--end::Title-->
                            </div>

                            <div class="d-flex align-items-center">
                                <!--begin::Symbol-->
                                <div class="symbol symbol-30px me-2">
                                    <div class="symbol-label bg-transparent">
                                        <i class="fad fa-skull fs-1 text-info"></i>
                                    </div>
                                </div>
                                <!--end::Symbol-->
                                <!--begin::Title-->
                                <div>
                                    <div class="fs-4 text-dark fw-bold lh-2 ls-deaths">${data.deaths}</div>
                                    <div class="fs-5 text-primary fw-bolder lh-1 text-nowrap">D</div>
                                </div>
                                <!--end::Title-->
                            </div>
                            
                        </div>
                    </div>
                </div>                
            `;

            if($(".livestream-overlay").find(`.ls-pscore[data-steamid="${data.steamid}"]`).length)
            {
                $(".livestream-overlay").find(`.ls-pscore[data-steamid="${data.steamid}"]`).html(`${html}`);
            }
            else
            {
                $(".livestream-overlay").find(data.team == 1 ? '.ls-pscore-t' : '.ls-pscore-ct').append(`<div class="card my-0 mx-0 ls-pscore rounded-0 card-flush" data-steamid="${data.steamid}" style="background-color: rgba(31,31,31,0.85);">${html}</div>`);
            }
            
        }
    }
}

function removePlayerScore(data){
    if($(".livestream-overlay").find(`.ls-pscore[data-steamid="${data.steamid}"]`).length)
    {
        $(".livestream-overlay").find(`.ls-pscore[data-steamid="${data.steamid}"]`).remove();
    }
}

function showPscores()
{
    $(".ls-pscore-ct").addClass("animate__fadeInRight").removeClass("animate__fadeOutRight");
    $(".ls-pscore-t").addClass("animate__fadeInLeft").removeClass("animate__fadeOutLeft");
}

function hidePscores()
{
    $(".ls-pscore-ct").removeClass("animate__fadeInRight").addClass("animate__fadeOutRight");
    $(".ls-pscore-t").removeClass("animate__fadeInLeft").addClass("animate__fadeOutLeft");
}

function renderPlayer(data){

    //console.log(data.action);
    if($(".livestream-overlay").find(`.ls-slot[data-steamid="${data.steamid}"]`).length)
    {
        if(data.action == 'connected')
        {
            buildPlayer(data);
        }
        else if(data.action == 'health')
        {
            $(".livestream-overlay").find(`.ls-slot[data-steamid="${data.steamid}"]`).find(".ls-hp").css("width", data.hp+"%");
            $(".livestream-overlay").find(`.ls-slot[data-steamid="${data.steamid}"]`).find(".ls-hpp").text(data.hp);
            $(".livestream-overlay").find(`.ls-slot[data-steamid="${data.steamid}"]`).find(".ls-armor").text(data.armor);
        }
        else if(data.action == 'name')
        {
            $(".livestream-overlay").find(`.ls-slot[data-steamid="${data.steamid}"]`).find(".ls-nick").text(data.nick === undefined ? data.steamid.replace("BOT:", "") : data.nick);
        }
        else if(data.action == 'pickdropweapon')
        {
            
            if(data.sec == 0 && data.prim > 0)
            {
                $(".livestream-overlay").find(`.ls-slot[data-steamid="${data.steamid}"]`).find(".ls-prim").attr("src", `assets/media/weapons/${data.prim}.png`);
                $(".livestream-overlay").find(`.ls-slot[data-steamid="${data.steamid}"]`).find(".ls-sec").attr("src", `assets/media/weapons/0.png`);
                
            }
            if(data.sec > 0 && data.prim == 0)
            {
                $(".livestream-overlay").find(`.ls-slot[data-steamid="${data.steamid}"]`).find(".ls-sec").attr("src", `assets/media/weapons/0.png`);
                $(".livestream-overlay").find(`.ls-slot[data-steamid="${data.steamid}"]`).find(".ls-prim").attr("src", `assets/media/weapons/${data.sec}.png`);
            }
            if(data.sec > 0 && data.prim > 0)
            {
                $(".livestream-overlay").find(`.ls-slot[data-steamid="${data.steamid}"]`).find(".ls-prim").attr("src", `assets/media/weapons/${data.prim}.png`);
                $(".livestream-overlay").find(`.ls-slot[data-steamid="${data.steamid}"]`).find(".ls-sec").attr("src", `assets/media/weapons/${data.sec}.png`);
            }
            if(data.sec == 0 && data.prim == 0)
            {
                $(".livestream-overlay").find(`.ls-slot[data-steamid="${data.steamid}"]`).find(".ls-prim").attr("src", `assets/media/weapons/${data.prim}.png`);
                $(".livestream-overlay").find(`.ls-slot[data-steamid="${data.steamid}"]`).find(".ls-sec").attr("src", `assets/media/weapons/${data.sec}.png`);
            }

        }
        else if(data.action == 'bombdrop')
        {
            $(".livestream-overlay").find(`.ls-slot[data-steamid="${data.steamid}"]`).find(".ls-hasc4").addClass("d-none");
        }
        else if(data.action == 'bombpickup')
        {
            $(".livestream-overlay").find(`.ls-slot[data-steamid="${data.steamid}"]`).find(".ls-hasc4").removeClass("d-none");
        }
        else if(data.action == 'defdrop')
        {
            $(".livestream-overlay").find(`.ls-slot[data-steamid="${data.steamid}"]`).find(".ls-hasdef").addClass("d-none");
        }
        else if(data.action == 'defpickup')
        {
            $(".livestream-overlay").find(`.ls-slot[data-steamid="${data.steamid}"]`).find(".ls-hasdef").removeClass("d-none");
        }
        else if(data.action == 'money')
        {
            $(".livestream-overlay").find(`.ls-slot[data-steamid="${data.steamid}"]`).find(".ls-money").text(data.money);
        }
        else if(data.action == 'kills')
        {
            $(".livestream-overlay").find(`.ls-slot[data-steamid="${data.steamid}"]`).find(".ls-kills").text(data.kills);
        }
        else if(data.action == 'deaths')
        {
            $(".livestream-overlay").find(`.ls-slot[data-steamid="${data.steamid}"]`).find(".ls-deaths").text(data.deaths);
        }
        else if(data.action == 'assists')
        {
            $(".livestream-overlay").find(`.ls-slot[data-steamid="${data.steamid}"]`).find(".ls-assists").text(data.assists);
        }
        else if(data.action == 'kevlar')
        {
            if(data.kev == 0){
                $(".livestream-overlay").find(`.ls-slot[data-steamid="${data.steamid}"]`).find(".ls-kev").addClass("d-none");
            }
            if(data.kev == 1){
                $(".livestream-overlay").find(`.ls-slot[data-steamid="${data.steamid}"]`).find(".ls-kev").removeClass("d-none");
                $(".livestream-overlay").find(`.ls-slot[data-steamid="${data.steamid}"]`).find(".ls-vesthelm").addClass("d-none");
                $(".livestream-overlay").find(`.ls-slot[data-steamid="${data.steamid}"]`).find(".ls-vest").removeClass("d-none");
            }
            if(data.kev == 2){
                $(".livestream-overlay").find(`.ls-slot[data-steamid="${data.steamid}"]`).find(".ls-kev").removeClass("d-none");
                $(".livestream-overlay").find(`.ls-slot[data-steamid="${data.steamid}"]`).find(".ls-vest").addClass("d-none");
                $(".livestream-overlay").find(`.ls-slot[data-steamid="${data.steamid}"]`).find(".ls-vesthelm").removeClass("d-none");
            }
        }
        else if (data.action == 'buynade') {
            if (data.he > 0) {
                $(".livestream-overlay").find(`.ls-slot[data-steamid="${data.steamid}"]`).find(".ls-he").removeClass("d-none")
            } else {
                $(".livestream-overlay").find(`.ls-slot[data-steamid="${data.steamid}"]`).find(".ls-he").addClass("d-none")
            }

            if (data.fb > 0) {
                if (data.fb == 1) {
                    $(".livestream-overlay").find(`.ls-slot[data-steamid="${data.steamid}"]`).find(".ls-fb-2").addClass("d-none")
                    $(".livestream-overlay").find(`.ls-slot[data-steamid="${data.steamid}"]`).find(".ls-fb-1").removeClass("d-none");
                }
                if (data.fb == 2) {
                    $(".livestream-overlay").find(`.ls-slot[data-steamid="${data.steamid}"]`).find(".ls-fb-2").removeClass("d-none")
                    $(".livestream-overlay").find(`.ls-slot[data-steamid="${data.steamid}"]`).find(".ls-fb-1").removeClass("d-none");
                }
            } else {
                $(".livestream-overlay").find(`.ls-slot[data-steamid="${data.steamid}"]`).find(".ls-fb-2").addClass("d-none")
                $(".livestream-overlay").find(`.ls-slot[data-steamid="${data.steamid}"]`).find(".ls-fb-1").addClass("d-none");
            }

            if (data.sg > 0) {
                $(".livestream-overlay").find(`.ls-slot[data-steamid="${data.steamid}"]`).find(".ls-sg").removeClass("d-none")
            } else {
                $(".livestream-overlay").find(`.ls-slot[data-steamid="${data.steamid}"]`).find(".ls-sg").addClass("d-none")
            }
        } else if (data.action == 'respawn') {
            
        } else if (data.action == 'dead') {                        

            $(".livestream-overlay").find(`.ls-slot[data-steamid="${data.steamid}"]`).find(".ls-alive").addClass("d-none");
            $(".livestream-overlay").find(`.ls-slot[data-steamid="${data.steamid}"]`).find(".ls-dead").removeClass("d-none");
        } else {
            //$(".livestream-overlay").find(`.ls-slot[data-steamid="${data.steamid}"]`).html(html);
            buildPlayer(data);
        }
        
    }
    else
    {
        buildPlayer(data);
    }
    


    function buildPlayer(data) {
        if(data.team > 0 && data.team < 3){
            let html = /* html */`            
                <div class="card-body p-0  position-relative ls-alive ${data.dead == 0 ? "" : "d-none"}" style="min-height:38px">
                    <div class="d-flex flex-stack h-100 mx-2 ${data.team == 2 ? 'flex-row-reverse' : ''}">
                        <div class="d-flex align-items-center ${data.team == 2 ? 'flex-row-reverse' : ''}">
                            <!--<div class="symbol symbol-40px me-3">
                                <img src="${data.avatar === undefined ? "assets/media/avatars/default.jpg" : data.avatar}" class="" alt="">
                            </div>-->

                            <div class="d-flex align-items-center justify-content-center w-30px ${data.team == 1 ? 'me-3' : 'ms-3'}">
                                <span class="text-gray-900 ls-hpp fs-2 text-center z-index-3">${data.hp}</span>
                            </div>
                            
                            <div class="d-flex justify-content-start flex-column">
                                <span class="text-white fw-bolder text-hover-white fs-4 text-uppercase lh-2 text-nowrap text-truncate mw-200px z-index-3 ls-nick">${data.nick === undefined ? data.steamid.replace("BOT:", "") : data.nick}</span>
                                <div class="d-flex flex-row gap-2 lh-3 text-gray-600 fw-bold fs-4">                                                        
                                </div>
                            </div>
                        </div> 
                        <div class="h-35px z-index-3 ">
                            <!--<img class="ls-curw h-100 ${data.team == 1 ? 'mirror' : ''}" src="assets/media/weapons/${data.curw === undefined ? "0" : data.curw}.png"/>-->
                            <img class="ls-prim h-100 ${data.team == 1 ? 'mirror' : ''}" src="assets/media/weapons/${data.prim === undefined || data.prim == 0 ? data.sec : data.prim}.png"/>
                            
                        </div>                   
                    </div>
                    <div class="progress h-100 w-100 position-absolute left-0 top-0 z-index-0 rounded-0 ${data.team == 2 ? 'mirror' : ''}" style="background:transparent;opacity:0.9">
                        <div class="progress-bar ls-hp" role="progressbar" style="width:${data.hp}%;${data.team == 1 ? 'background: rgb(253,29,29);background: linear-gradient(90deg, rgba(253,29,29,1) 50%, rgba(252,176,69,1) 100%);' : 'background: rgb(111,30,255);background: linear-gradient(90deg, rgba(111,30,255,1) 50%, rgba(0,123,255,1) 100%);'}"></div>
                        <!--<div class="progress-bar ls-hp ${data.team == 1 ? 'bg-success' : 'bg-info'}" role="progressbar" style="width:${data.hp}%;"></div>-->


                    </div>
                </div>
                <div class="card-footer p-0 ls-alive ${data.dead == 0 ? "" : "d-none"} d-flex align-items-center justify-content-between ${data.team == 2 ? 'flex-row-reverse' : ''}" style="min-height:38px">
                    <div class="d-flex mx-2 gap-2 ${data.team == 2 ? 'flex-row-reverse' : ''}" style="width:120px">
                        <div class="d-flex align-items-center w-50px ${data.team == 2 ? 'flex-row-reverse' : ''}">
                            <div class="h-30px py-1 ls-kev ${data.kev === undefined || data.kev == 0 ? "d-none" : ""}">
                                <img class="h-100 ls-vest ${data.kev == 1 ? "" : "d-none"}" src="assets/media/weapons/31.png"/>
                                <img class="h-100 ls-vesthelm ${data.kev == 2 ? "" : "d-none"}" src="assets/media/weapons/32.png"/>
                            </div>  
                            <div class="ls-hasc4 h-35px py-1 ${data.bomb === undefined || data.bomb == 0 ? "d-none" : ""}">
                                <img class="h-100" src="assets/media/weapons/6.png"/>
                            </div>
                            <div class="ls-hasdef h-30px py-1 ${data.def === undefined || data.def == 0 ? "d-none" : ""}">
                                <img class="h-100" src="assets/media/weapons/defusekit.png"/>
                            </div>                                                      
                        </div> 

                        <div class="d-flex align-items-center">
                            <div class="text-nowrap">
                                <span class="text-success fs-4">$ <span class="ls-money">${data.money}<span></span>
                            </div>                            
                        </div> 
                    </div>

                    <div class="d-flex align-items-center ls-nades">
                        <div class="d-flex gap-1 align-items-center justify-content-center h-35 py-1 fs-5">
                            <span class="h-30px ls-he ${data.he == 1 ? '' : 'd-none'}"><img class="h-100" src="assets/media/weapons/4.png"/></span>
                            <span class="h-30px ls-fb-1 ${data.fb == 1 || data.fb == 2 ? '' : 'd-none'}"><img class="h-100" src="assets/media/weapons/25.png"/></span>
                            <span class="h-30px ls-fb-2 ${data.fb == 2 ? '' : 'd-none'}"><img class="h-100" src="assets/media/weapons/25.png"/></span>
                            <span class="h-30px ls-sg ${data.sg == 1 ? '' : 'd-none'}"><img class="h-100" src="assets/media/weapons/9.png"/></span>
                        </div>
                    </div>

                    <div class="h-30px z-index-3 opacity-50 w-100px ${data.team == 1 ? 'me-2 text-end' : 'ms-2 text-start'}">
                        <img class="ls-sec h-100 ${data.team == 1 ? 'mirror' : ''}" src="assets/media/weapons/${data.sec === undefined || data.prim == 0 || data.sec == 0 ? "0" : data.sec}.png"/>
                    </div>
                </div>


                <div class="card-body p-0  position-relative ls-dead ${data.dead == 1 ? "" : "d-none"}" style="min-height:38px">
                    <div class="d-flex flex-stack mx-2 ${data.team == 2 ? 'flex-row-reverse' : ''}">
                        <div class="d-flex align-items-center ${data.team == 2 ? 'flex-row-reverse' : ''}">
                            <!--<div class="symbol symbol-40px me-3">
                                <img src="${data.avatar === undefined ? "assets/media/avatars/default.jpg" : data.avatar}" class="" alt="">
                            </div>-->

                            <div class="d-flex align-items-center justify-content-center h-35px w-30px py-1 ${data.team == 1 ? 'me-3' : 'ms-3'}">
                                <img class="h-100" src="assets/media/icons/dead.png"/>
                            </div>
                            
                            <div class="d-flex justify-content-start flex-column">
                                <span class="text-white fw-bolder text-hover-white fs-4 text-uppercase lh-2 text-nowrap text-truncate mw-200px z-index-3 ls-nick">${data.nick === undefined ? data.steamid.replace("BOT:", "") : data.nick}</span>
                                <div class="d-flex flex-row gap-2 lh-3 text-gray-600 fw-bold fs-4">
                                </div>
                            </div>
                        </div> 
                        <div class="h-30px  z-index-3 py-1">
                            
                        </div>                   
                    </div>                    
                </div>
                <div class="card-footer p-0 ls-dead ${data.dead == 1 ? "" : "d-none"} d-flex align-items-center" style="min-height:38px">
                    <div class="d-flex justify-content-between align-items-center mx-2 w-100  ${data.team == 2 ? 'flex-row-reverse' : ''}">
                        <div class="d-flex align-items-center flex-nowrap">
                            <span class="text-success fs-4">$ <span class="ls-money">${data.money}<span></span>
                        </div>
                                                                         
                        <div class="d-flex flex-row mx-2 gap-2">
                            <div class="d-flex align-items-center">
                                <!--
                                <div class="symbol symbol-30px me-3">
                                    <div class="symbol-label bg-transparent">
                                        <i class="fad fa-skull fs-2 text-info"></i>
                                    </div>
                                </div>-->                        
                                <!--begin::Title-->
                                <div class="text-center w-20px">
                                    <div class="fs-6 text-gray-800 fw-bold lh-1">K</div>
                                    <div class="fs-5 text-dark fw-bold lh-2 ls-kills">${data.kills}</div>
                                </div>
                                <!--end::Title-->
                            </div>
                            <div class="d-flex align-items-center">
                                <!--
                                <div class="symbol symbol-30px me-3">
                                    <div class="symbol-label bg-transparent">
                                        <i class="fad fa-skull fs-2 text-info"></i>
                                    </div>
                                </div>-->                        
                                <!--begin::Title-->
                                <div class="text-center w-20px">
                                    <div class="fs-6 text-gray-800 fw-bold lh-1">A</div>
                                    <div class="fs-5 text-dark fw-bold lh-2 ls-assists">${data.assists}</div>                                            
                                </div>
                                <!--end::Title-->
                            </div>
                            <div class="d-flex align-items-center">
                                <!--
                                <div class="symbol symbol-30px me-3">
                                    <div class="symbol-label bg-transparent">
                                        <i class="fad fa-skull fs-2 text-info"></i>
                                    </div>
                                </div>-->                        
                                <!--begin::Title-->
                                <div class="text-center w-20px">
                                    <div class="fs-6 text-gray-800 fw-bold lh-1">D</div>
                                    <div class="fs-5 text-dark fw-bold lh-2 ls-deaths">${data.deaths}</div>                                            
                                </div>
                                <!--end::Title-->
                            </div>
                        </div>
                        
                        
                    </div>
                                        
                    
                </div>
            `;

            if($(".livestream-overlay").find(`.ls-slot[data-steamid="${data.steamid}"]`).length)
            {
                $(".livestream-overlay").find(`.ls-slot[data-steamid="${data.steamid}"]`).html(`${html}`);
            }
            else
            {
                $(".livestream-overlay").find(data.team == 1 ? '.ls-team-t' : '.ls-team-ct').append(`<div class="card my-0 mx-0 ls-slot rounded-0 card-flush" data-steamid="${data.steamid}" style="background-color: rgba(31,31,31,0.85);">${html}</div>`);
            }
            
        }
    }
}


function fancyTimeFormat(duration) {
    // Hours, minutes and seconds
    const hrs = ~~(duration / 3600);
    const mins = ~~((duration % 3600) / 60);
    const secs = ~~duration % 60;
  
    // Output like "1:01" or "4:03:59" or "123:03:59"
    let ret = "";
  
    if (hrs > 0) {
      ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
    }
  
    ret += "" + mins + ":" + (secs < 10 ? "0" : "");
    ret += "" + secs;
  
    return ret;
  }


  function animateImage(imgClass, animationNames, durations = '1s', loop = false, onComplete) {
    // Selecciona la imagen usando la clase
    var $image = $(imgClass);

    // Convierte `animationNames` en un array si no lo es, para soportar múltiples animaciones
    if (!Array.isArray(animationNames)) {
        animationNames = [animationNames];
    }

    // Si `durations` no es un array, lo convertimos a array para soportar múltiples duraciones
    if (!Array.isArray(durations)) {
        durations = Array(animationNames.length).fill(durations);
    }

    // Establece una duración por defecto en caso de que no se proporcione una específica
    const defaultDuration = '1.5s';

    // Función interna para aplicar cada animación en secuencia
    function applyAnimations(index = 0) {
        if (index >= animationNames.length) {
            // Si hemos terminado todas las animaciones y no está en loop, finalizamos.
            if (!loop) {
                if (typeof onComplete === 'function') {
                    onComplete();
                }
                return;
            } else {
                // Reiniciar el ciclo si está en loop
                index = 0;
            }
        }
        
        // Quitar cualquier clase previa de animación
        $image.removeClass('animate__animated ' + animationNames.map(name => `animate__${name}`).join(' '));

        // Añadir la siguiente clase de animación
        var currentAnimation = animationNames[index];
        var currentDuration = durations[index] || defaultDuration;  // Usa duración personalizada o por defecto
        $image.css('animation-duration', currentDuration);
        $image.addClass(`animate__animated animate__${currentAnimation}`);
        
        // Escuchar el evento cuando la animación termine
        $image.one('animationend', function() {
            // Al completar, proceder a la siguiente animación
            applyAnimations(index + 1);
        });
    }

    // Iniciar el ciclo de animaciones
    applyAnimations();
}


export default livestream;